<template>
  <div>
    <el-input
      v-if="dataType == '01'"
      size="mini"
      v-model="engValName"
    ></el-input>
    <!--文本域-->
    <el-input
      type="textarea"
      placeholder="请输入内容"
      v-model="engValName"
      maxlength="30"
      show-word-limit
      :rows="3"
      v-else-if="dataType == '04'"
      size="mini"
    >
    </el-input>
    <!--单选-->
     <el-select clearable 
      v-model="engValName"
      placeholder="请选择"
      size="mini"
      v-else-if="dataType == '02'"
      style="width: 100%"
    >
      <el-option
        v-for="(item_2, index_2) in sPlatProVals"
        :key="index_2"
        :label="item_2.engValName + '(' + item_2.valName + ')'"
        :value="item_2.valId"
      >
      </el-option>
    </el-select>
    <!--多选-->
    <el-select clearable 
      v-model="engValName"
      multiple
      placeholder="请选择"
      size="mini"
      v-else-if="dataType == '03'"
      style="width: 100%"
    >
      <el-option
        v-for="(item_2, index_2) in sPlatProVals"
        :key="index_2"
        :label="item_2.engValName + '(' + item_2.valName + ')'"
        :value="item_2.valId"
      >
      </el-option>
    </el-select>
    <!--枚举多选-->
    <div v-else-if="dataType == '06'" class="attrVal">
     <el-checkbox :indeterminate="isIndeterminate" v-model="engValName" @change="checkde">全选</el-checkbox>
     <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="engValName" @change="checkedManyVal">
        <el-checkbox
          v-for="(item_2, index_2) in sPlatProVals"
          :key="index_2"
          :label="item_2.valId"
          >{{ item_2.engValName + "(" + item_2.valName + ")" }}</el-checkbox
        >
      </el-checkbox-group>
    </div>

    <!--枚举单选-->
   <div v-else-if="dataType == '05'" class="attrVal">
      <el-radio
        v-model="engValName"
        :key="index_2"
        :label="item_2.valId"
        v-for="(item_2, index_2) in sPlatProVals"
        >{{ item_2.engValName + "(" + item_2.valName + ")" }}</el-radio
      >
    </div>
    <!--时间-->
    <el-date-picker
      v-model="engValName"
      type="datetime"
      placeholder="选择日期时间"
      v-else-if="dataType == '07'"
    >
    </el-date-picker>
  </div>
</template>

<script>
export default {
  props: {
    sPlatProVals: Array,
    engValName: {
      type: String,
      default: "",
    },
    dataType: {
      type: String,
      default: "01",
    },
  },
  data() {
    return {}
  },
}
</script>

<style></style>
